import CountrySelector from '../components/CountrySelector';
import appMobileLogo from '../assets/images/app-icon.png';
import playStoreImage from '../assets/images/playstore.svg';
import appStoreImage from '../assets/images/appstore.svg';
import { useTranslation } from 'react-i18next';

const RightContent = () => {
    const { t } = useTranslation();
    return (
        <div className="u-right-content">
            <div className="u-login-box">
                <h2 className="h-md-light">{t('loginSection.countrySelectionTitle')}</h2>
                <p className="t-md-regular">{t("loginSection.countrySelectionText1")} <b>{t("loginSection.countrySelectionText2")}</b> {t("loginSection.countrySelectionText3")} </p>
                <CountrySelector />
            </div>
            <div className="u-login-box">
                <h2 className="h-md-light">{t('loginSectionRight.orTheApp')}</h2>
                <div className="u-row u-atacarnet-app">
                    <div className="u-atacarnet-logo-container">
                        <img className="u-atacarnet-logo" src={appMobileLogo} alt={t('home.mobileAppLogo')} />
                    </div>
                    <div className="u-atacarnet-store-links">
                        {/* <h3 className="h-sm-light">{t('header.altText')}</h3> */}
                        <a href="https://play.google.com/store/apps/details?id=org.iccwbo.atacarnet">
                            <img src={playStoreImage} alt={t('home.playStoreImage')} />
                        </a>
                        <a href="https://apps.apple.com/gb/app/ata-carnet/id1470367115">
                            <img src={appStoreImage} alt={t('home.appStoreImage')} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RightContent;